//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_CATEGORICAL = {
    color: [
        'var(--ods-categorical-1, #085ebd)',
        'var(--ods-categorical-2, #27a971)',
        'var(--ods-categorical-3, #bc4d9a)',
        'var(--ods-categorical-4, #9373bd)',
        'var(--ods-categorical-5, #9d6e06)',
        'var(--ods-categorical-6, #333333)',
        'var(--ods-categorical-7, #3e9dd6)',
        'var(--ods-categorical-8, #0a6e31)',
        'var(--ods-categorical-9, #d573bb)',
        'var(--ods-categorical-10, #492191)',
        'var(--ods-categorical-11, #b98f11)',
        'var(--ods-categorical-12, #666666)',
    ],
};
